// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Default, Desktop, Mobile, Tablet } from '../../utils/responsive';
import Slider from 'react-slick';
import classNames from 'classnames/bind';
import Arrow from '../Arrow/Arrow';

import style from './CarouselItems.scss';
import icons from '../../assets/styles/icons.scss';

import type { Element } from 'react';

type Props = {
  carouselItems: Element<'article'>[];
  handleArrowStyle: (current: number, lastIndex: number) => void;
  lightningLeftArrow: boolean;
  lightningRightArrow: boolean;
  hasFixedItems?: boolean;
};

export default class CarouselItems extends Component<Props> {
  render() {
    const { carouselItems, handleArrowStyle, lightningLeftArrow, lightningRightArrow, hasFixedItems } = this.props;
    // console.log(carouselItems);
    const options = {
      arrows: true,
      draggable: true,
      infinite: false,
      slidesToScroll: 1,
      speed: 500,
      dots: true,
      dotsClass: classNames('slick-dots', style.dots),
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={style.arrowRight}
                        visible={lightningRightArrow}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={style.arrowLeft}
                        visible={lightningLeftArrow}/>,
    };
    const mobileSettings = {
      ...options,
      slidesToShow: 1,
      afterChange: (current) => handleArrowStyle(current, carouselItems.length - 1),
    };
    const tableSettings = {
      ...options,
      slidesToShow: 4,
      dots: false,
      afterChange: (current) => handleArrowStyle(current, carouselItems.length - 4),
    };
    const desktopSettings = {
      ...options,
      slidesToShow: 5,
      dots: false,
      afterChange: (current) => handleArrowStyle(current, carouselItems.length - 5),
    };
    const content = hasFixedItems ?
      <Fragment>
        <Mobile>
          {carouselItems.slice(0, 4)}
        </Mobile>
        <Tablet>
          {carouselItems.slice(0, 4)}
        </Tablet>
        <Desktop>
          {carouselItems.slice(0, 5)}
        </Desktop>
      </Fragment> :
      <Fragment>
        <Mobile>
          <Slider {...mobileSettings}>
            {carouselItems}
          </Slider>
        </Mobile>
        <Tablet>
          <Slider {...tableSettings}>
            {carouselItems}
          </Slider>
        </Tablet>
        <Desktop>
          <Slider {...desktopSettings}>
            {carouselItems}
          </Slider>
        </Desktop>
      </Fragment>;
    return (
      <section className={classNames(style.carousel, { [style.b]: !hasFixedItems })}>
        {content}
      </section>
    );
  }
}

CarouselItems.propTypes = {
  carouselItems: PropTypes.array.isRequired,
  handleArrowStyle: PropTypes.func.isRequired,
  lightningLeftArrow: PropTypes.bool.isRequired,
  lightningRightArrow: PropTypes.bool.isRequired,
  hasFixedItems: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/CarouselItems/CarouselItems.jsx